import { signal } from "@preact/signals-react";
import { useQuery } from "@tanstack/react-query";

import SearchBar from "componentsv2/widgets/SearchBar";
import CheckGrid from "../components/CheckGrid";
import { layout as layoutFolio } from "../models/folio";
import { useGlobal } from "storev2/globalStore";
import { cn } from "tools/ui";

const location = signal(null);
const wordsSearch = signal(null);

const styleLocation =
  "w-28 md:ml-2  text-neutral-700 text-xs border border-neutral-400 p-2 rounded-lg active:scale-95 cursor-pointer shadow-md";

function CheckFolios({ globalSearch, getFolios, queryKey }) {
  // const layout = layoutFolio();
  const { customStore } = useGlobal();

  const { data, refetch } = useQuery({
    queryKey: [queryKey],
    queryFn: async () => getFolios(location, wordsSearch),
  });

  function handleFilter(value) {
    if (value === location.value) {
      location.value = null;
    } else {
      location.value = value;
    }
    refetch();
  }

  function handleSearch(value) {
    wordsSearch.value = value;
    if (wordsSearch.value && wordsSearch.value.length < 2) {
      return;
    }
    refetch();
  }

  return (
    <div className="w-full  bg-neutral-100 p-4">
      <div className="flex max-md:flex-col mb-2 mt-2 max-md:space-y-2">
        <span className="font-medium text-neutral-500 my-auto text-xl md:mx-4">
          LOCACIONES
        </span>
        <div className="flex max-md:space-x-3">
          {customStore.locations.map((item) => (
            <div
              className={cn(
                styleLocation,
                location.value === item.id ? "bg-lime-200" : "bg-stone-200",
              )}
              key={item.id}
              onClick={() => handleFilter(item.id)}
            >
              {item.name}
            </div>
          ))}
        </div>

        <div className="ml-3"></div>
        <SearchBar
          name="search-widget"
          handleSearch={handleSearch}
          size="w-1/3 h-12"
        />
      </div>
      <CheckGrid
        records={data?.pendingCheck}
        title="Pendientes"
        isLoading={false}
        refetch={refetch}
      />
      <CheckGrid
        records={data?.doneCheck}
        title="Realizados"
        isLoading={false}
        refetch={refetch}
      />
    </div>
  );
}

export default CheckFolios;
